import { type CSSProperties, type MouseEvent as ReactMouseEvent } from 'react';
import BulbIcon from '~/images/icons/BulbIcon';
import { Colors } from '~/themes/colors';
import { Text } from '../Text';

interface ITipsButtonProps {
  onClick(e: ReactMouseEvent<HTMLButtonElement>): void;
}

const Styles = {
  Button: {
    all: 'unset',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    height: 30,
    width: 85,
    backgroundColor: Colors.secondary_500,
    borderRadius: 24,
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 3px 10px 1px rgba(0, 0, 0, 0.15)',
    transition: 'transform 0.2s ease-in-out',
  } as CSSProperties,
};

export const TipsButton = ({ onClick }: ITipsButtonProps) => (
  <button
    type="button"
    style={Styles.Button}
    onClick={onClick}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.05)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
    }}
  >
    <BulbIcon />
    <Text bold color={Colors.white} marginTop={2}>
      Tips
    </Text>
  </button>
);
